@if (maintenanceMessage?.length > 0) {
    <div class="downtime-banner p-component p-messages p-messages-info">
        <i class="pi pi-exclamation-triangle"></i><span class="downtime-text" [innerHTML]="maintenanceMessage"></span>
    </div>
}
<app-navbar></app-navbar>
<router-outlet></router-outlet>
